import { Component, Input, OnInit } from '@angular/core';
import { BalanceQuery, config, MemberQuery, ScreenType } from '@fgb/core';
import { map, Observable } from 'rxjs';
import { Location } from '@angular/common';
import { Populations } from 'src/app/shared/utilities/populations';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input() backButtonLink?: string;
  @Input() qrButtonLink: string = '/rewards/wallet';
  @Input() pageTitle: string;
  @Input() kidsBanner: string;
  @Input() welcomeLink: string;
  @Input() homepage: boolean = false;
  @Input() showBalance: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() showBanner: boolean = true;
  screenType = ScreenType;
  populations = Populations;
  pointsBalance$: Observable<number | undefined>;
  memberData$: Observable<{ name: string; externalRefNumber: string }>;

  constructor(
    private balanceQuery: BalanceQuery,
    private location: Location,
    private router: Router,
    private memberQuery: MemberQuery
  ) { }

  ngOnInit() {
    this.memberData$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => ({
        name: m?.FirstName ?? '',
        externalRefNumber: m?.ExternalRefNumber ?? '',
      }))
    );
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }
}
